import React from 'react'
import classnames from 'classnames'
import Link from '../Link/Link'

interface BreadcrumbItemProps {
  active: boolean
  children: React.ReactNode
  href: string
  noHover?: boolean
  collapseMobile?: boolean
}

export const BreadcrumbItem = ({ active, children, href, noHover, collapseMobile }: BreadcrumbItemProps) => {
  const styles = {
    item: classnames(
        'breadcrumb-item text-black font-weight-bold',
        { 'active': active },
        { 'in-active': !active },
        { 'text-gray-600': noHover }
    ),
    mobile: classnames(
        { 'd-none d-sm-block': collapseMobile }
    ),
    link: classnames(
        'rounded font-weight-bold text-black',
        { 'bg-gray-300 text-black': !noHover },
        { 'no-hover p-0': noHover }
    )
  }

  if (active) {
    return (
        <li className={`${styles.mobile} ${styles.item}`}>
            {children}
        </li>
    )
  } else {
    return (
        <li className={styles.item}>
            <Link
                classNames={styles.link}
                to={href}
            >
                {children}
            </Link>
        </li>
    )
  }
}
